import React from "react";
import PropTypes from "prop-types";

export const TwoColumnLayout = ({ 
  children, 
  leftContent,
  logoSrc = "/design/images/login-page/breathe-logo-icon.svg",
  showMobileLogo = true,
  rightContentHeader,
  contentMaxWidth,
}) => {
  return (
    <div className="fixed inset-0 z-50 bg-white">
      <div className="flex flex-col md:flex-row h-full w-full shadow-lg">
        {/* Left Column - Side Content */}
        <div className="hidden md:flex flex-1 flex-col items-start p-6 md:p-10 overflow-hidden login-bg-gray relative">
          {leftContent || (
            <>
              <div className="flex gap-2 items-center mb-10">
                <img
                  src={logoSrc}
                  alt="Breathe logo icon"
                  className="h-8 w-9"
                />
              </div>
              <div className="flex-1 flex flex-col items-center justify-center w-full">
                {/* Placeholder for custom content */}
              </div>
            </>
          )}
        </div>

        {/* Right Column - Main Content */}
        <div className="flex-1 bg-white flex flex-col gap-4 p-6 md:p-10 min-w-0 overflow-y-auto">
          {/* Mobile Header - Logo and Logout inline on mobile */}
          <div className="flex md:hidden items-center justify-between mb-4 flex-shrink-0">
            {showMobileLogo && (
              <div className="flex gap-2 items-center">
                <img
                  src={logoSrc}
                  alt="Breathe logo icon"
                  className="h-8 w-9"
                />
              </div>
            )}
            {rightContentHeader && (
              <div className="flex">
                {rightContentHeader}
              </div>
            )}
          </div>
          
          {/* Desktop Logout - Only visible on desktop */}
          {rightContentHeader && (
            <div className="hidden md:flex justify-end flex-shrink-0">
              {rightContentHeader}
            </div>
          )}
          
          <div className="flex-1 flex flex-col items-center justify-start md:justify-center gap-6 w-full min-h-0">
            <div 
              className="w-full login-form-container"
              style={contentMaxWidth ? { maxWidth: `${contentMaxWidth}px` } : {}}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TwoColumnLayout.propTypes = {
  children: PropTypes.node.isRequired,
  leftContent: PropTypes.node,
  logoSrc: PropTypes.string,
  showMobileLogo: PropTypes.bool,
  rightContentHeader: PropTypes.node,
  contentMaxWidth: PropTypes.number,
};

TwoColumnLayout.defaultProps = {
  leftContent: null,
  logoSrc: "/design/images/login-page/breathe-logo-icon.svg",
  showMobileLogo: true,
  rightContentHeader: null,
  contentMaxWidth: null,
};

